import i18n from "i18next";
import './i18n';

// Get the `t` function with the specific namespace and keyPrefix
// @ts-ignore
const tSplash = i18n.getFixedT(null, "translation", "frontend.splash") as (key: string, args?: any) => string;

export { tSplash };
